module.exports = __webpack_public_path__ + "img/Haefele_menu2.dd04c10a.png";